import { Inject, InjectionToken, Injector, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'

import { SessionService } from '../services/session/session.service'

import { CurrencyPipe } from '../pipes/currency.pipe';
import { DatePipe } from '../pipes/date.pipe';
import { DecimalPipe } from '../pipes/decimal.pipe';
import { NumberPipe } from '../pipes/number.pipe';
import { PercentPipe } from '../pipes/percent.pipe';
import { RoundPipe } from '../pipes/round.pipe';
import { DurationPipe } from '../pipes/duration.pipe';
import { toLower } from 'lodash';

@Pipe({ name: 'format' })
export class FormatPipe implements PipeTransform {
  FORMATS = {
    currency: CurrencyPipe,
    date: DatePipe,
    decimal: DecimalPipe,
    number: NumberPipe,
    percent: PercentPipe,
    revenue: CurrencyPipe,
    round: RoundPipe,
    time: DurationPipe,
  }

  constructor(@Inject(LOCALE_ID) locale: string, session: SessionService) {

    for (const type in this.FORMATS) {  
      const formatTypeToken = new InjectionToken(type);
      const injector = Injector.create(
        {
          providers:
            [
              { provide: LOCALE_ID, useValue: locale },
              { provide: SessionService, useValue: session },
              { provide: formatTypeToken, useClass: this.FORMATS[type], deps: [LOCALE_ID, SessionService] }
            ]
        }
      )

      this.FORMATS[type] = injector.get(formatTypeToken);
    }
  }

  transform(value: any, options?: any): any {
    if (value == null || toLower(value) === 'n/a') {
      return 'n/a'
    }

    let format
    const opts = {}
    if (options == null || Object.isString(options)) {
      format = options
    } else {
      format = options['format']
      Object.merge(opts, options)
      delete opts['format']
    }

    let pipe = this.FORMATS[format]
    if (!pipe) {
      if (typeof(value) === 'number') {
        pipe = this.FORMATS['number']
      } else {
        return value
      }
    }

    try {
      return pipe.transform(value, opts)
    } catch(e) {
      if (e.toString().includes('InvalidPipeArgument') || e.toString().includes('NG02100')) {
        return value
      } else {
        throw(e)
      }
    }
  }
}
